import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  text: string;
  href?: string;
  scrollToId?: string;
  className?: string;
}
export const CtaButton: React.FC<CtaButtonProps> = ({
  text,
  href = 'https://pay.hotmart.com/T105897049N',
  scrollToId,
  className = ''
}) => {
  const baseClasses = `inline-block text-center bg-electric text-white font-bold py-5 px-8 rounded-lg w-full text-lg uppercase tracking-wide shadow-lg cursor-pointer no-underline ${className}`;
  if (scrollToId) {
    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault();
      const target = document.getElementById(scrollToId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        // Fallback: scroll to bottom of page
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }
    };
    return <motion.button type="button" onClick={handleClick} whileHover={{
      scale: 1.02,
      filter: 'brightness(1.1)'
    }} whileTap={{
      scale: 0.98
    }} className={baseClasses} data-id="element-28">
        {text}
      </motion.button>;
  }
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02,
    filter: 'brightness(1.1)'
  }} whileTap={{
    scale: 0.98
  }} className={baseClasses} data-id="element-29">
      {text}
    </motion.a>;
};